import { useState } from "react";
import tongue from "../../images/tongue.png";
import background2 from '../../images/background2.png';
import suitability from '../../images/suitability.png';
import taboos from '../../images/taboos.png';
import { checkStatusType } from "../const";
import { Image } from "antd";
import ColorBar from "./ColorBar";
import TongueCheck from "./TongueCheck";

export default function TongueDiagnosisResult({
    dataList,
    row,
    id,
}: any) {
    const tongueColors = ['#EDE7DB', '#FFCECE', '#FF7474', '#EE0D16', '#9A38BD'];
    const tongueColorsName = ['淡白', '淡红', '红', '绛红', '青紫'];
    const coatingColors = ['#EDE7DB', '#C49347', '#928989'];
    const coatingColorsName = ['淡白', '黄色', '灰黑'];
    const [isCheckVisible, setIsCheckVisible] = useState<boolean>(false);
    const removePTags = (html: string): string => {
        return html.replace(/<p>/g, '').replace(/<\/p>/g, '');
    };
    const getExpandedData = () => {
        const foundItem: any = dataList?.find((item: any) => item?.id === id);
        return foundItem;
    }
    const tongueFeatures: any = () => {
        const expandedData = getExpandedData();
        const features = expandedData?.resultData?.checkResult?.tongueFeatures || [];
        const tongue = expandedData?.resultData?.parsingResult?.tongue || [];

        let tongueColor: any[] = [];
        let tongueShape: any[] = [];
        let coatingColor: any[] = [];
        let coatingQuality: any[] = [];

        let foundCoatingColor = false; // 是否已找到第一个“苔色”

        for (let i = 0; i < features.length; i++) {
            const feature = features[i];

            // 在 tongue 中查找匹配的 { contentName } 对象
            const matchedItem = tongue.find((item: any) => item.contentName === feature);

            if (i === 0) {
                // 第一个是舌色
                if (matchedItem) {
                    tongueColor.push(matchedItem);
                }
            } else if (!foundCoatingColor && feature.endsWith("苔")) {
                // 找到第一个以“苔”结尾的作为苔色
                if (matchedItem) {
                    coatingColor.push(matchedItem);
                    foundCoatingColor = true;
                }
            } else {
                if (!foundCoatingColor) {
                    // 苔色未出现前的是舌形
                    if (matchedItem) {
                        tongueShape.push(matchedItem);
                    }
                } else {
                    // 苔色之后的是苔质
                    if (matchedItem) {
                        coatingQuality.push(matchedItem);
                    }
                }
            }
        }

        return {
            "tongueColor": tongueColor,
            "tongueShape": tongueShape,
            "coatingColor": coatingColor,
            "coatingQuality": coatingQuality,
        };
    };

    if (tongueFeatures().tongueColor.length === 0) {
        const expandedData = getExpandedData();
        if (!expandedData) {
            return <div style={{ display: "flex", justifyContent: "space-around" }}>
                检测结果不存在或已被删除
            </div>
        }
        return <>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
                <div>检测状态：{checkStatusType[row?.status]?.text || row.status}</div>
                <div>检测图片：<Image width={25} height={50} src={expandedData?.imageUrl} /></div>
                <div>原因:{row.reason}</div>
            </div>
        </>
    }

    const value = getExpandedData()?.resultData?.parsingResult?.diagnosis;
    return (
        <div className="expandRow">
            <div style={{ width: '23%' }} >
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper"
                        style={{
                            backgroundImage: `url(${background2})`,
                            backgroundPosition: 'bottom center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: '100% 30%',
                            zIndex: 1,
                            paddingBottom: 22,
                        }}>
                        <div className="tongue-title" style={{ color: '#666666' }}>诊断结果</div>
                        <div style={{
                            position: 'absolute',
                            top: '15px',
                            right: '10px',
                            backgroundColor: '#E1EED8',
                            color: '#4A9C41',
                            padding: '4px 8px',
                            borderRadius: '9px',
                            fontSize: '15px',
                            fontWeight: '500px',
                            lineHeight: '20px',
                            textAlign: 'center',
                            fontStyle: 'normal',
                            textTransform: 'none',
                        }}>
                            {value?.level}
                        </div>
                        <div className="tongue-content" style={{ fontWeight: 400 }}>
                            <div style={{
                                color: '#333333',
                                fontSize: '22px',
                                lineHeight: '31px',
                                fontWeight: '600px',
                                marginBottom: '10px',
                            }}>{value?.result}</div>
                            <span dangerouslySetInnerHTML={{ __html: removePTags(value?.explanation) }}></span>
                        </div>
                    </div>
                </div>
                <div className="title">舌象特征分析</div>
                <div className="imageBox">
                    <img src={tongue}
                        style={{ width: '100%', height: '100%' }}
                        alt="舌象" />
                    <button
                        className="imgShowBtn"
                        style={{
                            backgroundImage: `url(${getExpandedData()?.resultData?.checkResult?.cropUrl})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                        onClick={() => { setIsCheckVisible(true) }}>查看图像</button>
                    {isCheckVisible && <TongueCheck
                        record={getExpandedData()}
                        tongueFeatures={tongueFeatures()}
                        visible={isCheckVisible}
                        onCancel={() => setIsCheckVisible(false)}
                    />}
                </div>
                <div className="tongue-title" style={{ color: '#666666' }}>舌色</div>
                {tongueFeatures().tongueColor.map((item: any, index: number) => (
                    <div key={index}>
                        <ColorBar
                            colors={tongueColors}
                            colorsName={tongueColorsName}
                            selectedColorName={item.contentName} />
                        <div key={index} className="tongue-content tongue-color">
                            <span style={{ color: '#94724B', fontSize: 16, fontWeight: 500 }}>{item.contentName}：</span>
                            <span dangerouslySetInnerHTML={{ __html: removePTags(item.mediaList[0].description) }}></span>
                        </div>
                    </div>
                ))}
                <div className="box-container">
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title" style={{ color: '#666666' }}>舌形</div>
                        {tongueFeatures().tongueShape.map((item: any, index: number) => (
                            <div key={index} className="tongue-content">
                                <span style={{ color: '#94724B', fontSize: 16, fontWeight: 500 }}>{item.contentName}：</span>
                                <span dangerouslySetInnerHTML={{ __html: removePTags(item.mediaList[0].description) }}></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ width: '23%' }}>
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title" style={{ color: '#666666' }}>苔色</div>
                        {tongueFeatures().coatingColor.map((item: any, index: number) => (
                            <div key={index} className="tongue-content">
                                <ColorBar
                                    colors={coatingColors}
                                    colorsName={coatingColorsName}
                                    selectedColorName={item.contentName} />
                                <span style={{ color: '#94724B', fontSize: 16, fontWeight: 500 }}>{item.contentName}：</span>
                                <span dangerouslySetInnerHTML={{ __html: removePTags(item.mediaList[0].description) }}></span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="box-container">
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title" style={{ color: '#666666' }}>苔质</div>
                        {tongueFeatures().coatingQuality.map((item: any, index: number) => (
                            <div key={index} className="tongue-content">
                                <span style={{ color: '#94724B', fontSize: 16, fontWeight: 500 }}>{item.contentName}：</span>
                                <span dangerouslySetInnerHTML={{ __html: removePTags(item.mediaList[0].description) }}></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ width: '23%' }}>
                <div className="title">病症介绍</div>
                <div className="box-container">
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title">病症介绍</div>
                        <div className="tongue-content">{value?.symptomsIntroduction}</div>
                    </div>
                </div>
            </div>
            <div style={{ width: '23%' }}>
                <div className="title">调理建议</div>
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title">食疗调理建议</div>
                        <div className="tongue-content">{value?.foodTherapySuggestions}</div>
                    </div>
                </div>
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper"
                        style={{
                            backgroundImage: `url(${suitability})`,
                            backgroundPosition: 'top right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'auto 60px',
                            position: 'relative',
                            zIndex: 1
                        }}>
                        <div className="tongue-title">食疗宜食</div>
                        <div className="tongue-content">{value?.foodBetter}</div>
                    </div>
                </div>
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper"
                        style={{
                            backgroundImage: `url(${taboos})`,
                            backgroundPosition: 'top right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'auto 60px',
                            position: 'relative',
                            zIndex: 1
                        }}>
                        <div className="tongue-title">食疗忌食</div>
                        <div className="tongue-content">{value?.foodWorse}</div>
                    </div>
                </div>
                <div className="box-container" style={{ marginBottom: 10 }}>
                    <div className="tongue-content-wrapper">
                        <div className="tongue-title">中医调理建议</div>
                        <div className="tongue-content">{value?.medicineTherapySuggestions}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}